// src/admin/components/Sidebar.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Home,
  Building2,
  Users,
  Calendar,
  BarChart3,
  Settings,
  LogOut,
  PlusCircle,
  Menu,
  X,
  Mail,
  UserCircle
} from 'lucide-react';
import { authService } from '../../services/auth';
import { formatImageUrl } from '../../services/api';

const Sidebar = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const user = authService.getUser();

  const handleLogout = () => {
    authService.logout();
  };

 const menuItems = [
  { path: '/admin', icon: Home, label: 'Dashboard', exact: true },
  { path: '/admin/properties', icon: Building2, label: 'Propiedades' },
  { path: '/admin/properties/new', icon: PlusCircle, label: 'Nueva Propiedad' },
  { path: '/admin/users', icon: Users, label: 'Usuarios' }, // NUEVO
  { path: '/admin/messages', icon: Mail, label: 'Consultas' },
  { path: '/admin/appointments', icon: Calendar, label: 'Citas' },
  { path: '/admin/reports', icon: BarChart3, label: 'Reportes' },
  { path: '/admin/profile', icon: UserCircle, label: 'Mi Perfil' },
  { path: '/admin/settings', icon: Settings, label: 'Configuración' },
];

  const sidebarContent = (
    <>
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <Building2 className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-gray-800">Sanz Berger</h1>
            <p className="text-xs text-gray-500">Panel Admin</p>
          </div>
        </div>
      </div>

      {/* Información del usuario */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          {user?.avatar ? (
            <img
              src={formatImageUrl(user.avatar)}
              alt={user.name}
              className="w-10 h-10 rounded-full object-cover flex-shrink-0"
            />
          ) : (
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="font-bold text-blue-600">
                {user?.name?.charAt(0) || 'A'}
              </span>
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="font-medium text-gray-800 truncate">{user?.name || 'Administrador'}</p>
            <p className="text-sm text-gray-500 truncate">{user?.email || 'admin@sanzberger.com'}</p>
          </div>
        </div>
      </div>

      {/* Menú de navegación */}
      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.exact}
                onClick={() => setIsMobileOpen(false)}
                className={({ isActive }) => `
                  flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors
                  ${isActive
                    ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600'
                    : 'text-gray-700 hover:bg-gray-50'
                  }
                `}
              >
                <item.icon className="w-5 h-5" />
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 w-full px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut className="w-5 h-5" />
          <span>Cerrar Sesión</span>
        </button>
      </div>

      {/* Versión */}
      <div className="p-4 border-t border-gray-200">
        <p className="text-xs text-gray-500 text-center">
          Versión 1.0.0
        </p>
      </div>
    </>
  );

  return (
    <>
      {/* Botón hamburguesa - solo mobile */}
      <button
        onClick={() => setIsMobileOpen(true)}
        className="md:hidden fixed top-4 left-4 z-40 p-2 bg-white border border-gray-200 rounded-lg shadow-md"
        aria-label="Abrir menú"
      >
        <Menu className="w-6 h-6 text-gray-700" />
      </button>

      {/* Overlay - solo mobile, cuando el sidebar está abierto */}
      {isMobileOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar: drawer deslizable en mobile, fijo en desktop */}
      <div
        className={`fixed left-0 top-0 h-full w-64 bg-white border-r border-gray-200 flex flex-col z-50 transform transition-transform duration-300 md:translate-x-0 ${
          isMobileOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <button
          onClick={() => setIsMobileOpen(false)}
          className="md:hidden absolute top-4 right-4 p-1 text-gray-500 hover:bg-gray-100 rounded-lg"
          aria-label="Cerrar menú"
        >
          <X className="w-5 h-5" />
        </button>
        {sidebarContent}
      </div>
    </>
  );
};

export default Sidebar;